import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import './jquery.webGtmHandler';

export default class WebGtmHandler extends WebComponent {
  didMount() {
    $(this.element).webGtmHandler({
      gtmPageData: window.gtmPageData || {},
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebGtmHandler.js